import { render, staticRenderFns } from "./GiftBoxIcon.vue?vue&type=template&id=edb40ff6&"
import script from "./GiftBoxIcon.vue?vue&type=script&lang=ts&"
export * from "./GiftBoxIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('edb40ff6', component.options)
    } else {
      api.reload('edb40ff6', component.options)
    }
    module.hot.accept("./GiftBoxIcon.vue?vue&type=template&id=edb40ff6&", function () {
      api.rerender('edb40ff6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/icons/GiftBoxIcon.vue"
export default component.exports